import React, { useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";
import QrReader from "react-qr-reader";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import { getQrOrderDetails } from "../../network/ApiAxios";
import { redirectToLogout } from "common/SharedFn";
import { ArrowBack } from "@material-ui/icons";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const ScanQrPage = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const [alert, setAlert] = React.useState(false);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [success, setSuccess] = React.useState(false);
  const [showError, setShowError] = React.useState(false);
  const [id, setId] = useState();
  const [forceRefresh, setForceRefresh] = useState(false);
  const [qrTagRead, setQrTagRead] = useState(false);
  let history = useHistory();

  const handleQrScan = (data) => {
    if (data && !qrTagRead) {
      setQrTagRead(true);
      fetchOrderDetails(data);
    }
  };
  const handleQrError = (err) => {
    console.error(err);
  };

  const fetchOrderDetails = async (tag) => {
    setIsLoading(true);
    try {
      const response = await getQrOrderDetails(tag);
      const { data } = response;
      if (data.result.isSuccess) {
        if (data.data.id != null) {
          accessOrderPage(data.data.id);
        }
      } else {
        showErrorNotification(data.result.description);
        setQrTagRead(false);
        if (data.result.code == -2) {
          redirectToLogout();
        }
        setIsLoading(false);
      }
    } catch (ex) {
      showErrorNotification("Order not found " + tag);
      setQrTagRead(false);
      setIsLoading(false);
    }
    
  };

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const accessOrderPage = (id) => {
    let history = createHistory();
    history.push("/admin/laundryOrders/" + id);
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };

  useAsyncEffect(async () => {}, []);

  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>
              <CardHeader
                subheader={
                  <>
                  
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >

<Tooltip title="Back">
                        <Button
                          size="small"
                          classes={{
                            root: classes.buttonContainedPrimary,
                          }}
                          variant="contained"
                          style={{ marginRight: "20px" }}
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          <Box component={ArrowBack} />
                        </Button>
                      </Tooltip>
                      <Box component="span">Scan QR</Box>
                    </Box>
                  </>
                }
                classes={{ root: classes.cardHeaderRoot }}
              ></CardHeader>
              {isLoading ? (
                <Box
                  component={Grid}
                  container
                  justifyContent="center"
                  className="justify-content-center"
                >
                  <div className="text-center" style={{ width: "20%" }}>
                    <LoadingAnimation />{" "}
                  </div>
                </Box>
              ) : (
                <Box
                  component={Grid}
                  container
                  justifyContent="center"
                  className="justify-content-center"
                >
                
                  <QrReader
                    delay={300}
                    onError={handleQrError}
                    onScan={handleQrScan}
                    style={{ width: "50%" }}
                  />
                
                </Box>
              )}
            </Card>
          </Grid>
        </Grid>

        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default ScanQrPage;
